import { LayoutAdministrare } from "@/components/administrare/LayoutAdministrare";

export default function AdministrareDate() {
  return (
    <LayoutAdministrare
      titlu="Actualizare date"
      descriere={
        <>
          Sursele publice care alimentează universul de targetare: exportul
          ONRC, registrul de contribuabili ANAF, situațiile financiare MF,
          listele oficiale și neoficiale, nomenclatoarele și sursele fără
          snapshot propriu (Termene, descoperire web). Descărcarea și extragerea
          se fac local, cu pachetul{" "}
          <code className="font-mono">scripts/actualizare/</code>; aplicarea
          diferențelor față de starea curentă se face din acest ecran, pe
          fiecare sursă.
        </>
      }
    />
  );
}
